import styled from 'styled-components';
import React, { RefObject, useEffect, useState } from 'react';

import { Button } from '@components/atoms';
import { Navigate, Social } from 'components/molecules';

import useDevice from '@hooks/useDevice';
import Rocket from '@public/icons/rocket.svg';
import Logo from '@public/icons/logo_full.svg';
import { useIsClient } from '@hooks/useIsClient';
import { onLogoClick, scrollTo, scrollToPath } from '@utils/scrollTo';
import { JOIN, socialNavigation } from '@shared/constants/navigate';

type HeaderDesktopProps = {
  refs: RefObject<HTMLDivElement>[];
};

function HeaderDesktop({ refs }: HeaderDesktopProps) {
  const [pathname, setPathname] = useState('');
  const { isDesktop } = useDevice();
  const isClient = useIsClient();

  const onLinkClick = (e: React.MouseEvent<HTMLElement>) => {
    scrollToPath(e, pathname, refs);
  };

  const onJoinButtonClick = () => {
    window.location.href = JOIN;
  };

  const onCallButtonClick = () => {
    scrollTo(refs, 'contacts');
  };

  useEffect(() => {
    if (isClient) {
      const path = window.location.pathname.replace('/', '');

      setPathname(path);
    }
  }, [isClient]);

  return (
    <Wrapper>
      <LogoWrapper>
        <Logo onClick={onLogoClick} style={{ cursor: 'pointer' }} />
      </LogoWrapper>

      <Navigate ariaLabel="Site navigation" onLinkClick={onLinkClick} />

      {isDesktop && (
        <Social ariaLabel="Contact and social links" links={socialNavigation} />
      )}

      <ButtonWrapper $minWidth={!pathname ? '310px' : 'auto'}>
        <Button
          height="48px"
          width={pathname ? '210px' : '150px'}
          bgColor="textPrimary"
          color="white"
          title="Join Us"
          fontSize="18px"
          Icon={Rocket}
          onClick={onJoinButtonClick}
        />

        {!pathname && (
          <Button
            height="48px"
            width="150px"
            bgColor="forestGreen"
            margin="0 0 0 10px"
            color="white"
            title="Call Me"
            fontSize="18px"
            onClick={onCallButtonClick}
          />
        )}
      </ButtonWrapper>
    </Wrapper>
  );
}

const Wrapper = styled.div<{ $justifyContent?: boolean }>`
  height: 100%;
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const LogoWrapper = styled.div`
  width: 220px;

  display: flex;
  align-items: center;
  justify-content: flex-start;

  margin-right: 40px;
`;

const ButtonWrapper = styled.div<{ $minWidth?: string }>`
  min-width: ${({ $minWidth }) => $minWidth};
  height: 100%;

  display: flex;
  justify-content: end;
  align-items: center;
`;

export default HeaderDesktop;
